import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbTooltipModule, NgbNavModule, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { ContentPageComponent } from './content-page.component';
import { ContentPageRoutingModule } from './content-page-routing.module';

@NgModule({
    imports: [
        CommonModule,
        NgbTooltipModule,
        NgbNavModule,
        NgbCollapseModule,
        SharedModule,        
        RouterModule,
        ContentPageRoutingModule
    ],
    declarations: [
        ContentPageComponent
    ],
    providers: [         
    ]
})
export class ContentPageModule { }
